import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ListaServicosComponent } from './pages/categoria-servicos/lista/lista.component';

import { AgendamentoAtendimentoComponent } from './pages/agendamentos/atendimento/atendimento.component';
import { AuthGuard } from './auth/AuthGuard';

const routes: Routes = [
  {
    path: 'interno',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/interno/interno.module').then(m => m.InternoModule)
  },
  {
    path: 'servico',
    loadChildren: () =>
      import('./pages/servicos/servicos.module').then(m => m.ServicosModule)
  },
  { path: 'servicos', component: ListaServicosComponent },
  {
    path: 'agendamento',
    component: AgendamentoAtendimentoComponent,
  },
  { path: '', component: ListaServicosComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
